'use strict'

import HandbookApi from '@/api/dictionary/handbook.js'

const state = {
  loading: false,
  error: null,
  countries: []
}

const actions = {
  fetch ({ commit, dispatch }) {
    commit('fetch')

    return HandbookApi.fetchCountries()
      .then(res => commit('fetchSuccess', res))
      .catch(err => {
        commit('fetchFailure', err)
        dispatch('global/setError', err, {root: true})
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, res) {
    state.loading = false
    state.countries = res
  },

  fetchFailure (state, err) {
    state.loading = false
    state.error = err
  }
}

const getters = {
  countries: (state) => state.countries
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
